module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tllRemainingDays) ? _c('div', {
    staticClass: "m-tll"
  }, [_c('div', {
    staticClass: "m-tll__discount"
  }, [_vm._v("\n    Your prepaid credit - " + _vm._s(_vm.tllRemainingDays) + " days\n      "), _c('span', {
    staticClass: "a-tooltip",
    on: {
      "click": _vm.toggleTooltip,
      "mouseover": _vm.toggleTooltip,
      "mouseleave": _vm.toggleTooltip
    }
  }, [_c('span', {
    ref: "tooltipTrigger",
    staticClass: "a-tooltip__trigger"
  }, [_c('i', {
    staticClass: "fas fa-question-circle"
  })]), _vm._v(" "), _c('span', {
    ref: "tooltipBubble",
    staticClass: "a-tooltip__bubble a-tooltip__bubble--top"
  }, [_c('div', {
    staticClass: "a-tooltip__bubble__body"
  }, [_vm._v("\n            Your credit card will be billed after your prepaid balance has been used up.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "a-tooltip__arrow",
    attrs: {
      "data-popper-arrow": ""
    }
  })])])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.subscriptionPromotion) ? _c('div', {
    staticClass: "m-tll__description green-text"
  }, [_c('div', {
    staticClass: "row m-tll__description--title"
  }, [_c('span', [_vm._v("Discount")]), _vm._v(" - " + _vm._s(_vm.promotionDescription))]), _vm._v(" "), _c('div', {
    staticClass: "row m-tll__description--billingPeriod"
  }, [_vm._v("\n      " + _vm._s(_vm.currency) + " " + _vm._s(_vm.promotionOriginalPrice) + "\n      " + _vm._s(_vm.subscriptionBillingPeriodCycle(_vm.promotionProductBillingPeriod)) + " once promotion ends\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.promotionEndDate && _vm.promotionDescription) ? _c('hr') : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21982195","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/checkout/components/molecules/Tll.vue
// module id = 522
// module chunks = 2